import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _BookIcon;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CustomModal from '../../../components/Modals/Modal';
import Link from '../../../components/Link';
import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import BookIcon from '../../../components/statelessComponents/Icons/BookIcon';
import s from './AttachedCoursesModal.scss';
import { buildQuery, isTrial } from '../../../helpers';
import RestrictedAccessModal from '../../../components/RestrictedAccessModal/RestrictedAccessModal';
import isLoggedIn from '../../../helpers/checkAuth';
import ContextProvider from '../../../context';
var messages = defineMessages({
  title: {
    id: "LessonDetails.AttachedCoursesModal.title",
    defaultMessage: [{
      "type": 0,
      "value": "Are you interested in this topic? - See courses"
    }]
  },
  noCoursesText: {
    id: "LessonDetails.AttachedCoursesModal.noCoursesText",
    defaultMessage: [{
      "type": 0,
      "value": "This lesson isn’t currently included in any course."
    }]
  },
  fetchedAttachedCoursesError: {
    id: "LessonDetails.AttachedCoursesModal.fetchedAttachedCoursesError",
    defaultMessage: [{
      "type": 0,
      "value": "Oops, something went wrong!"
    }]
  }
});
var AttachedCoursesModal = function AttachedCoursesModal(_ref) {
  var onClose = _ref.onClose,
    numberOfAttachedCourses = _ref.numberOfAttachedCourses,
    lessonId = _ref.lessonId,
    auth = _ref.auth;
  var _useContext = useContext(ContextProvider),
    fetch = _useContext.fetch;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAttachedCoursesLoading = _useState2[0],
    setIsAttachedCoursesLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    attachedCoursesList = _useState4[0],
    setAttachedCoursesList = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRestrictedAccessModalOpened = _useState6[0],
    setIsRestrictedAccessModalOpened = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isAttachedCoursesLoadingError = _useState8[0],
    setIsAttachedCoursesLoadingError = _useState8[1];
  var fetchAttachedCourses = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var params, query, rawRes, resText, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!numberOfAttachedCourses || !lessonId)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          setIsAttachedCoursesLoading(true);
          _context.prev = 3;
          params = {
            useInLessonId: lessonId
          };
          query = buildQuery(params);
          _context.next = 8;
          return fetch("/api/courses/used-in-lesson?".concat(query));
        case 8:
          rawRes = _context.sent;
          _context.next = 11;
          return rawRes.text();
        case 11:
          resText = _context.sent;
          json = resText ? JSON.parse(resText) : [];
          if (!(rawRes.status >= 400)) {
            _context.next = 15;
            break;
          }
          throw new Error(rawRes.statusText);
        case 15:
          setAttachedCoursesList(json);
          _context.next = 22;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](3);
          console.error('Error fetching attached courses:', _context.t0);
          setIsAttachedCoursesLoadingError(true);
        case 22:
          _context.prev = 22;
          setIsAttachedCoursesLoading(false);
          return _context.finish(22);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 18, 22, 25]]);
  })), [numberOfAttachedCourses, lessonId, setIsAttachedCoursesLoading, setAttachedCoursesList]);
  useEffect(function () {
    fetchAttachedCourses();
  }, [fetchAttachedCourses]);
  var hasAccess = function hasAccess(course) {
    return isLoggedIn(auth) && course.isAvailable;
  };
  var checkAuth = function checkAuth(event, course) {
    if (hasAccess(course) && !isTrial(auth)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    setIsRestrictedAccessModalOpened(true);
  };
  var closeRestrictedAccessModal = function closeRestrictedAccessModal() {
    setIsRestrictedAccessModalOpened(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(CustomModal, {
    isOpen: true,
    width: "60%",
    isLoaderOn: isAttachedCoursesLoading,
    "data-test": "attached-courses-modal",
    "aria-describedby": "attached-courses-modal"
  }, void 0, numberOfAttachedCourses > 0 && !isAttachedCoursesLoadingError && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Typography, {
    variant: "h6"
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.title)), /*#__PURE__*/_jsx(List, {
    component: "nav",
    className: s.coursesList
  }, void 0, attachedCoursesList === null || attachedCoursesList === void 0 ? void 0 : attachedCoursesList.map(function (course) {
    return /*#__PURE__*/_jsx(Link, {
      "data-test-id": "PERtH2uPzb5OeqlATmNa8",
      to: "/courses/".concat(course.slug),
      className: s.courseListItem,
      onClick: function onClick(event) {
        return checkAuth(event, course);
      }
    }, course._id, /*#__PURE__*/_jsx("div", {
      className: s.bookIcon
    }, void 0, _BookIcon || (_BookIcon = /*#__PURE__*/_jsx(BookIcon, {
      color: "black"
    }))), /*#__PURE__*/_jsx("div", {}, void 0, course.name));
  }))), !numberOfAttachedCourses && /*#__PURE__*/_jsx("div", {
    className: s.noCoursesText
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "h6"
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.noCoursesText))), isAttachedCoursesLoadingError && /*#__PURE__*/_jsx("div", {
    className: s.noCoursesText
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "h6"
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.fetchedAttachedCoursesError))), /*#__PURE__*/_jsx(ModalCloseBtn, {
    "data-test-id": "leHXJACDGLIQ0YtQWH_r4",
    fitMobileLandscapeFullWidth: true,
    onClick: onClose
  })), /*#__PURE__*/_jsx(Modal, {
    open: isRestrictedAccessModalOpened,
    onClose: closeRestrictedAccessModal
  }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
    onClose: closeRestrictedAccessModal
  })));
};
export default compose(injectIntl, withStyles(s))(AttachedCoursesModal);